import React from 'react';
import MapComponent from './components/Map';

function App() {
  return <MapComponent />;
}

export default App;
